module.exports = __webpack_public_path__ + "img/2.6e24489a.jpg";